export const stickerNamesEn = {
  deadline: 'Deadline',
  repeat: 'Regular task',
  stopwatch: 'Stopwatch',
  timer: 'Timer',
  timetracking: 'Time tracking',
  user: 'User',
  text: 'Text field',
  numeric: 'Number field',
  string: 'State',
  sprint: 'Sprint'
}

export const stickerNamesRu = {
  deadline: 'Дедлайн',
  repeat: 'Регулярная задача',
  stopwatch: 'Секундомер',
  timer: 'Таймер',
  timetracking: 'Таймтрекинг',
  user: 'Исполнитель',
  text: 'Текстовое поле',
  numeric: 'Числовое поле',
  string: 'Состояния',
  sprint: 'Спринт'
}
